import { ChevronRight, FileText } from 'lucide-react'
import { BRAND } from '@/constants/brand'
import { countDocumentItems, type RfidDocumentRow } from '@/services/rfid.service'
import { getDocumentPlant } from '@/utils/document'
import { cn } from '@/utils/cn'

export type DocumentListRowProps = {
  document: RfidDocumentRow
  onClick: () => void
  className?: string
}

export function DocumentListRow({ document, onClick, className }: DocumentListRowProps) {
  const docNo = String(document.DocumentNo ?? '—')
  const customer = String(document.CustName ?? '—')
  const date = String(document.PostingDate ?? '')
  const plant = getDocumentPlant(document)
  const itemCount = countDocumentItems(document.Items)

  return (
    <button type="button" onClick={onClick} className={cn('rfid-doc-row', className)}>
      <span className="rfid-doc-row__icon">
        <FileText size={20} strokeWidth={2} />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-[13px] font-extrabold tabular-nums text-foreground">
          {docNo}
        </span>
        <span className="mt-0.5 block truncate text-[11.5px] text-muted-foreground">
          {customer}
        </span>
        {plant ? (
          <span className="mt-0.5 block truncate text-[10.5px] font-bold text-muted-foreground">
            Plant {plant}
          </span>
        ) : null}
      </span>
      <span className="flex shrink-0 flex-col items-end gap-1">
        {date ? (
          <span className="text-[11px] font-semibold text-muted-foreground">{date}</span>
        ) : null}
        {itemCount > 0 ? (
          <span className="text-[10px] font-semibold text-muted-foreground">
            {itemCount} item{itemCount === 1 ? '' : 's'}
          </span>
        ) : null}
        <ChevronRight size={16} color={BRAND} />
      </span>
    </button>
  )
}
